import { render } from "./PayrollJobs.vue?vue&type=template&id=918d14b8&ts=true"
import script from "./PayrollJobs.vue?vue&type=script&lang=ts"
export * from "./PayrollJobs.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__